import type { HTMLAttributes, ReactNode } from 'react';

export type CardProps = HTMLAttributes<HTMLElement> & {
  title?: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  icon?: ReactNode;
  elevated?: boolean;
  noPadding?: boolean;
  flush?: boolean;
  as?: 'section' | 'article' | 'div';
};

export function Card({
  title,
  subtitle,
  actions,
  icon,
  elevated,
  noPadding,
  flush,
  className = '',
  children,
  as: As = 'section',
  ...rest
}: CardProps) {
  const cls = ['card', elevated ? 'card-elevated' : '', noPadding ? 'no-padding' : '', flush ? 'flush' : '', className]
    .filter(Boolean)
    .join(' ');

  return (
    <As className={cls} {...rest}>
      {(title || actions) && (
        <header className="card-head">
          <div className="card-head-titles">
            {title ? (
              <div className="card-title-row">
                {icon ? <span className="card-title-icon">{icon}</span> : null}
                <h2 className="card-title">{title}</h2>
              </div>
            ) : null}
            {subtitle ? <p className="card-subtitle">{subtitle}</p> : null}
          </div>
          {actions ? <div className="card-actions">{actions}</div> : null}
        </header>
      )}
      <div className="card-body">{children}</div>
    </As>
  );
}
